import axios from 'axios'
import _ from 'underscore'

const CancelToken = axios.CancelToken

export default {

	api: process.env.VUE_APP_API,

	source: false,

	cancel: function() {

		if (this.source) this.source.cancel()

	},

	get: function(url, params) {

		params = params || {}

		this.source = CancelToken.source()

		if (_.isArray(url)) url = url.join('/')

		return new Promise(function(resolve, reject) {

			console.log('api', 'get', url, params)

			axios.get(this.api + url + '.json', {
				cancelToken: this.source.token,
				headers: {
					'Cache-Control': 'no-cache',
					'Pragma': 'no-cache',
					'Expires': '0',
				},
				params: params
			}).then(function(response) {

				if (_.isObject(response.data)) {

					resolve(response.data.data)

				} else {

					reject(null)

				}

			}.bind(this), function(json) {

				reject((json.response) ? json.response : null)

			})

		}.bind(this))

	},

	post: function(url, params) {

		params = params || {}

		if (_.isArray(url)) url = url.join('/')

		this.source = CancelToken.source()

		return new Promise(function(resolve, reject) {

			console.log('api', 'post', url, params)

			axios.post(this.api + url + '.json', params, {
				cancelToken: this.source.token
			}).then(function(response) {

				if (_.isObject(response.data)) {

					resolve(response.data.data)

				} else {

					reject({})

				}

			}.bind(this), function(json) {

				reject(json.response.data.data)

			})

		}.bind(this))

	},

	patch: function(url, params) {

		params = params || {}

		if (_.isArray(url)) url = url.join('/')

		return new Promise(function(resolve, reject) {

			console.log('api', 'patch', url, params)

			axios.patch(this.api + url + '.json', params).then(function(response) {

				if (_.isObject(response.data)) {

					resolve(response.data.data)

				} else {

					reject(null)

				}

			}.bind(this), function(json) {

				reject(json.response.data.data)

			})

		}.bind(this))

	},

	put: function(url, params) {

		params = params || {}

		if (_.isArray(url)) url = url.join('/')

		return new Promise(function(resolve, reject) {

			console.log('api', 'put', url, params)

			axios.put(this.api + url + '.json', params).then(function(response) {

				if (_.isObject(response.data)) {

					resolve(response.data.data)

				} else {

					reject(null)

				}

			}.bind(this), function(json) {

				reject(json.response.data.data)

			})

		}.bind(this))

	},

	delete: function(url) {

		if (_.isArray(url)) url = url.join('/')

		return new Promise(function(resolve, reject) {

			console.log('api', 'delete', url)

			axios.delete(this.api + url + '.json').then(function(response) {

				if (_.isObject(response.data)) {

					resolve(response.data.data)

				} else {

					reject(null)

				}

			}.bind(this), function(json) {

				reject(json.response.data.data)

			})

		}.bind(this))

	}

}